import React from "react";
import Typography from "@mui/material/Typography";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { CircularProgress } from "@mui/material";

import { styled } from "@mui/material/styles";

import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import { useTranslation } from "react-i18next";
import TimelineIcon from "@mui/icons-material/Timeline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import OnlineSignupChart from "./OnlineSignupCharts";
import Popover from "@mui/material/Popover";
import { numberFormat } from "app/utils/utils";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFFFFF",
    color: "#475259",
    boxShadow:
      "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);",
    minWidth: "16px",
    padding: "10px",
    borderRadius: "8px",
    pointer: "cursor",
  },
}));

const GraphTile = (props) => {
  const tileData = props.tileData ? props.tileData : "";
  const { t } = useTranslation();
  return (
    <JumboCardQuick
      title={
        <Typography fontWeight={"500"} variant={"h3"} color={tileData.color}>
          {/* {numberFormat(tileData.tileValue)} */}
          {props.loading ? (
            <CircularProgress size="20px" />
          ) : (
            numberFormat(tileData.tileValue)
          )}
        </Typography>
      }
      subheader={
        <Typography
          variant={"h6"}
          color={tileData.color}
          mb={0}
          sx={{ cursor: "pointer" }}
        >
          <LightTooltip title={tileData.titleTooltip} placement="bottom">
            <span>{tileData.title}</span>
          </LightTooltip>
        </Typography>
      }
      action={
        tileData.tradeType ? (
          <LightTooltip
            title={props.showTolltip ? props.tooltip : ""}
            placement="bottom"
          >
            <Typography
              variant={"body1"}
              color={tileData.iconColor}
              sx={{ cursor: "pointer" }}
            >
              {tileData.tardeValue}%
              {tileData.tardeValue > 0 && tileData.tradeType == "up" && (
                <TrendingUpIcon
                  sx={{ verticalAlign: "middle", fontSize: "1rem", ml: 0.5 }}
                />
              )}
              {tileData.tardeValue > 0 && tileData.tradeType == "down" && (
                <TrendingDownIcon
                  sx={{ verticalAlign: "middle", fontSize: "1rem", ml: 0.5 }}
                />
              )}
            </Typography>
          </LightTooltip>
        ) : (
          <TimelineIcon />
        )
      }
      // action={
      // <LightTooltip title={tileData.tooltip} placement="bottom">
      //   <Typography
      //     variant={"body1"}
      //     color={tileData.iconColor}
      //     sx={{ cursor: "pointer" }}
      //   >
      //     1.5%
      //     <TrendingUpIcon
      //       sx={{ verticalAlign: "middle", fontSize: "1rem", ml: 0.5 }}
      //     />
      //   </Typography>
      // </LightTooltip>
      // }
      reverse
      sx={{
        color: tileData.iconColor ? tileData.iconColor : tileData.color,
        borderTop: "4px solid " + tileData.color,
      }}
      //bgColor={["#c1b2e6", "#7352c7"]}
      bgColor={[tileData.bgColor]}
      wrapperSx={{ pb: 0 }}
    >
      <OnlineSignupChart
        color={tileData.color}
        shadowColor={tileData.color}
        data={tileData.graphData}
        title={tileData.title}
      />
    </JumboCardQuick>
  );
};

export default GraphTile;
